// Espejo de `functions/bandasPrecioPorSite.js` (deep-equal en
// `functions/bandasPrecioPorSite.parity.test.js`): los cortes de precio del
// conocimiento del ecosistema, POR SITE (ADR 2026-08-19 §4). La razón de cada
// decisión está allá; acá sólo viaja la tabla que usa el lector.
export const BANDAS_PRECIO_POR_SITE = {
  MLA: [
    { id: 'hasta-30k', hasta: 30000 },
    { id: '30k-60k', hasta: 60000 },
    { id: '60k-120k', hasta: 120000 },
    { id: '120k-300k', hasta: 300000 },
    { id: 'mas-300k', hasta: Infinity },
  ],
}

/**
 * La banda de un precio unitario en SU site, o null si el site no tiene tabla
 * (misma semántica que la del back, comparada en el parity test). PURA.
 */
export function bandaPrecioDe(precio, siteId) {
  const bandas = Object.prototype.hasOwnProperty.call(BANDAS_PRECIO_POR_SITE, siteId) ? BANDAS_PRECIO_POR_SITE[siteId] : null
  if (!bandas) return null
  return (bandas.find((b) => precio <= b.hasta) || bandas[bandas.length - 1]).id
}
